import { TypeOf } from "./types";

export type InterceptCustomElementCallback<T extends HTMLElement = HTMLElement> = (
    constructor: TypeOf<T>,
    options?: ElementDefinitionOptions
) => CustomElementConstructor;

const interceptedCustomElements = new Map<string, InterceptCustomElementCallback[]>();

export function interceptCustomElement<T extends HTMLElement = HTMLElement>(name: string, callback: InterceptCustomElementCallback<T>): void {
    let callbacks: InterceptCustomElementCallback[];

    if (interceptedCustomElements.has(name)) {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        callbacks = interceptedCustomElements.get(name)!;
    }
    else {
        callbacks = [];

        interceptedCustomElements.set(name, callbacks);
    }

    callbacks.push(callback as InterceptCustomElementCallback);
}

export function patchCustomElements(): void {
    // eslint-disable-next-line @typescript-eslint/unbound-method
    const originalCustomElementsDefine = customElements.define;

    customElements.define = function (
        name: string,
        constructor: CustomElementConstructor,
        options?: ElementDefinitionOptions
    ) {
        if (interceptedCustomElements.has(name)) {
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const interceptors = interceptedCustomElements.get(name)!;

            for (const interceptor of interceptors) {
                interceptor(constructor, options);
            }
        }

        originalCustomElementsDefine.call(this, name, constructor, options);
    };
}
